function getClosestValidDropIndex (index, validDropIndexes) {
  const closestValidDropIndex = validDropIndexes.reduce((a, b) => (Math.abs(b - index) < Math.abs(a - index) ? b : a));

  return closestValidDropIndex;
}

export default getClosestValidDropIndex;
